import React, { useContext, useEffect, useState } from 'react'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'
import axios from 'axios'
import { Spinner } from 'react-bootstrap'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { BusinessProfileContext } from 'src/business/context/BusinessProfileContext'
import { BusinessSetupContext } from 'src/business/layout/BusinessLayout'
import { HighlightedLeaders, UsersList } from './LeaderboardPageComponents'
import { LeaderboardSectionContainer, LeaderboardSectionTitle } from './LeaderboardPageStyles'
import { ThemeContext } from 'src/context/ThemeContext'

export default function Leaderboard(props) {
  // const { primaryCriteria } = props;
  const { secureSetupData } = useContext(BusinessSetupContext)
  const { profileData, businessCustomerDetails } = useContext(BusinessProfileContext)
  const { theme } = useContext(ThemeContext)
  const { unSecureSetupLoading, unSecureSetupData, unSecureSetupError } =
    useContext(UnsecureSetupContext)

  const [primaryCriteria, setPrimaryCriteria] = useState(secureSetupData?.statFields?.[0]?.id)

  const token = localStorage.getItem('token')
  const countryCode = localStorage.getItem('countryCode')

  const [nationalLeadersData, setNationalLeadersData] = useState(null)
  const [nationalRankData, setNationalRankData] = useState(null)
  const [globalLeadersData, setGlobalLeadersData] = useState(null)
  const [globalRankData, setGlobalRankData] = useState(null)
  const [comparisonMode, setComparisonMode] = useState('national')

  const getLeaders = async () => {
    try {
      const response = await axios.get(
        `${apiURL}/api/secure/bc/company/leaderboard?primaryCriteria=${primaryCriteria}&companyId=${businessCustomerDetails?.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            ...commonHeadersWeb,
            'ef-user-country-code': localStorage.getItem('countryCode'),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      setNationalLeadersData(response?.data)
      return response
    } catch (error) {
      console.log(error)
      return error
    }
  }

  const getMyRank = async () => {
    try {
      const response = await axios.get(
        `${apiURL}/api/secure/user/leaderboard/my-rank?primaryCriteria=${primaryCriteria}&country=${countryCode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            ...commonHeadersWeb,
            'ef-user-country-code': localStorage.getItem('countryCode'),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      setNationalRankData(response?.data)
      return response
    } catch (error) {
      console.log(error)
      return error
    }
  }

  const getLeadersGlobal = async () => {
    try {
      const response = await axios.get(
        `${apiURL}/api/secure/bc/company/leaderboard?primaryCriteria=${primaryCriteria}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            ...commonHeadersWeb,
            'ef-user-country-code': localStorage.getItem('countryCode'),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      setGlobalLeadersData(response?.data)
      return response
    } catch (error) {
      console.log(error)
      return error
    }
  }

  const getMyRankGlobal = async () => {
    try {
      const response = await axios.get(
        `${apiURL}/api/secure/user/leaderboard/my-rank?primaryCriteria=${primaryCriteria}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            ...commonHeadersWeb,
            'ef-user-country-code': localStorage.getItem('countryCode'),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      setGlobalRankData(response?.data)
      return response
    } catch (error) {
      console.log(error)
      return error
    }
  }

  useEffect(() => {
    getLeaders()
    getLeadersGlobal()
    if (profileData?.[primaryCriteria] > 0) {
      getMyRank()
      getMyRankGlobal()
    } else {
      setNationalRankData('ineligible')
      setGlobalRankData('ineligible')
    }
  }, [primaryCriteria])

  return (
    <>
      {Boolean(nationalLeadersData) && Boolean(globalLeadersData) ? (
        <LeaderboardSectionContainer themeType={theme}>
          <LeaderboardSectionTitle themeType={theme}>Company Leaderboard</LeaderboardSectionTitle>
          <HighlightedLeaders
            nationalLeadersData={nationalLeadersData}
            nationalRankData={nationalRankData}
            globalLeadersData={globalLeadersData}
            globalRankData={globalRankData}
            comparisonMode={comparisonMode}
            setComparisonMode={setComparisonMode}
            primaryCriteria={primaryCriteria}
            setPrimaryCriteria={setPrimaryCriteria}
            profileData={profileData}
            unSecureSetupData={unSecureSetupData}
            statFields={secureSetupData?.statFields}
            theme={theme}
            companyName={businessCustomerDetails.companyName}
          />

          <UsersList
            nationalLeadersData={nationalLeadersData}
            nationalRankData={nationalRankData}
            globalLeadersData={globalLeadersData}
            globalRankData={globalRankData}
            comparisonMode={comparisonMode}
            setComparisonMode={setComparisonMode}
            primaryCriteria={primaryCriteria}
            setPrimaryCriteria={setPrimaryCriteria}
            profileData={profileData}
            unSecureSetupData={unSecureSetupData}
            statFields={secureSetupData?.statFields}
            themeType={theme}
            companyName={businessCustomerDetails.companyName}
          />
        </LeaderboardSectionContainer>
      ) : (
        <Spinner animation="border" variant="light" size="md" />
      )}
    </>
  )
}
